import { createContext } from 'react'
import type { User } from 'firebase/auth'

export interface AuthContextValue {
  user: User | null
  loading: boolean
  isAdmin: boolean
  /** Non-null UID when the user is signed in (not anonymous). */
  signedInUid: string | null
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  loading: true,
  isAdmin: false,
  signedInUid: null,
})
